export const OutstandingKeys = {
  all: ['OutstandingChart'],
  detail: (
    companyId: string,
    resolution: OutstandingChartResolution,
    periodCount: number,
    accountId: string[] | null,
  ) => ['OutstandingChart', companyId, resolution, periodCount, { accountId }],
};

export enum OutstandingChartResolution {
  Day = 'day',
  Month = 'month',
}

export enum OutstandingDataDirection {
  Inflow = 'inflow',
  Outflow = 'outflow',
}
